import React, { type CSSProperties, type HTMLAttributes, memo, type ReactNode, type RefObject, Suspense, useRef } from 'react';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { propsEqualityFn } from '../../utils/object-utils';
import { cn } from '../../utils/ui';

interface RenderOnViewportEntryProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
    className?: string;
    rootMargin?: string;
    style?: CSSProperties;
    ref?: RefObject<HTMLDivElement | null>;
}

const RenderOnViewportEntry = (props: RenderOnViewportEntryProps) => {
    const { children, className = '', style, ref: forwardedRef } = props;
    const internalRef = useRef<HTMLDivElement>(null);
    const rootMargin = props.rootMargin || '0px 0px 100px 0px';
    const { inView } = useIntersectionObserver(internalRef, { threshold: 0, rootMargin, triggerOnce: true });

    const ref = forwardedRef || internalRef;

    return (
        <div className={cn('', className)} ref={ref} style={style}>
            {inView && <Suspense fallback={null}>{children}</Suspense>}
        </div>
    );
};

export default memo(RenderOnViewportEntry, propsEqualityFn);
